import React, { useEffect, useState } from "react";
import { Row, Select, Typography } from "antd";
import { API_CONFIG } from "pages/config";
import { apiFetch } from "utils/apiFetch";
import { useAuth } from "../../AuthContext";
const { Text } = Typography;
const { Option } = Select;
export default function AntdHeader({ name }) {
  const { user, updateTenant } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [tenantId, setTenantId] = useState(() => {
    return Number(localStorage.getItem("tenantId") || localStorage.getItem("mockdb:tenantId") || user?.TenantId || 1);
  });

  useEffect(() => {
    const loadTenants = async () => {
      try {
        const res = await apiFetch(API_CONFIG.tenantsListUrl, { method: "POST" });
        const data = await res.json();
        setTenants(data.tenants || []);
      } catch {
        setTenants([]);
      }
    };
    loadTenants();
  }, []);

  const handleTenantChange = (value) => {
    const tenant = tenants.find((t) => t.id === value);
    if (!tenant) return;
    setTenantId(value);
    updateTenant(tenant);
    window.location.reload();
  };

  return (
    <>
      <Row align="middle" justify="end" style={{ paddingRight: 16 }}>
        {user?.RoleId === 5 && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Text type="secondary">Tenant</Text>
            <Select
              size="small"
              value={tenantId}
              onChange={handleTenantChange}
              style={{ minWidth: 200 }}
            >
              {tenants.map((tenant) => (
                <Option key={tenant.id} value={tenant.id}>{tenant.name}</Option>
              ))}
            </Select>
          </div>
        )}
      </Row>
    </>
  );
}
